import { useEffect, useState, useRef } from 'react'
import { debounce } from '@/utils/helper.utils'

export function useDebounce<T>(value: T, delay = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)
  const debounceRef = useRef<ReturnType<typeof debounce> | null>(null)
  const delayRef = useRef(delay)

  useEffect(() => {
    delayRef.current = delay
  }, [delay])

  useEffect(() => {
    if (debounceRef.current) {
      debounceRef.current.cancel()
    }
    debounceRef.current = debounce((...args: unknown[]) => {
      const debouncedArg = args[0] as T
      setDebouncedValue(debouncedArg)
    }, delayRef.current)
    debounceRef.current.trigger(value)

    return () => {
      debounceRef.current?.cancel()
    }
  }, [value, delay])

  return debouncedValue
}
